import React from 'react';

import ReturnInstructionsBox from 'components/account/Returns/ReturnInstructionsBox';

import css from 'styles/containers/returns/returnInstructionsBox.scss';

const ReturnInstructionsBoxes = ({ steps }) => (
  <div className={css.boxes}>
    {steps.map(({ description, img, title }) => (
      <ReturnInstructionsBox image={img} key={title} title={title}>
        {description}
      </ReturnInstructionsBox>
    ))}
  </div>
);

export default ReturnInstructionsBoxes;
